import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { sessionEndedRoute } from '../route-names';

@Component({
    selector: 'app-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss'],
    standalone: false
})
export class SurveyComponent {

  organization: string;
  surveyLink: string;
  constructor(private readonly router: Router) {
    this.organization = environment.organization
    this.surveyLink = environment.surveyLink
   }
  exit() {
    this.router.navigate(sessionEndedRoute)
  }

}
